module.exports = __webpack_public_path__ + "static/media/angel-capital-logo-1.7ea6dd51.png";